module.exports = __webpack_public_path__ + "img/custom.3c087a4d.png";